import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
   
    
}
const mutations={
   
    
    getAttrNameData(state,value){
        
        
     
        post(urls.admin.attr_name.getList,value).then((result)=>{
          console.log(result)  
          state.result=result
         
          
          
       
        
       
           
        });
        
    }

}
const  actions={
    getAttrNameDataAction(context,value){
       
        context.commit("getAttrNameData",value)
       
    },
  
    
   

}

export default {state,mutations,actions}